<template>
  <div class="main">
      <video controls>
      <source src="@/assets/video/cebei.mp4" type="video/mp4">
      </video>
  </div>
</template>

<script>
export default {
  name: "Product_cebei_mp4",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.main{
  text-align: center;
  margin-top: 20px;
  width: 100%;
}
</style>
